"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHomeTestimonials = exports.defaultHomeTestimonialVideo = exports.defaultHomeTestimonial1 = void 0;
exports.defaultHomeTestimonial1 = {
    agentId: 13,
    description: 'I really can\'t speak highly enough about Tiffany, she is a really welcoming face and capable operator not with standing the local language barriers. I will be recommending her to all my friends and I know she will make a very successful agent for OKAY.com. You have an excellent network. Thank you so much for all her efforts!!',
    rate: 4.8,
    agentName: 'Yohanita Tajuddin (Sayaka)',
    agentImage: 'https://images.okay.com/AgentThumbnail/Source/581_636663148845061393.jpg',
    agentTitle: 'Senior Consultant',
};
exports.defaultHomeTestimonialVideo = {
    youtube: 'https://www.youtube.com/embed/tz8St3jOfyA'
};
exports.defaultHomeTestimonials = [exports.defaultHomeTestimonial1, exports.defaultHomeTestimonial1, exports.defaultHomeTestimonialVideo, exports.defaultHomeTestimonial1, exports.defaultHomeTestimonial1];
